export default __webpack_public_path__ + "static/media/profile-1.14df7474.webp";